import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GerenciadorComponent } from './gerenciador.component';
import { InicioComponent } from './dashboard/inicio/inicio.component';
import { EventosComponent } from './dashboard/eventos/eventos.component';
import { UsuarioComponent } from './dashboard/usuario/usuario.component';
import { AlterarSenhaComponent } from './dashboard/alterar-senha/alterar-senha.component';
import { GaleriaFormComponent } from './dashboard/galeria-form/galeria-form.component';

const routes: Routes = [
  { path: 'gerenciador', 
    component: GerenciadorComponent,
      children: [
        {
          path: 'inicio',
          component: InicioComponent
        },
        {
          path: 'galeria',
          component: GaleriaFormComponent
        },
        {
          path: 'eventos', 
          component: EventosComponent
        },
        {
          path: 'usuario', 
          component: UsuarioComponent
        },
        {
          path: 'alterarSenha', 
          component: AlterarSenhaComponent
        },
      ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GerenciadorRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/gerenciador/gerenciador-routing.module.ts